import { Component } from 'react';

import { translate } from 'utils/translate';

import { SETTINGS } from '../settings';

class AccessForbidden extends Component {
    render() {
        return (
            <div className="flex flex-col items-center justify-center w-full h-screen text-center">
                <h1>{`403 | ${translate('Access Forbidden')}`}</h1>
                <p className="mt-4 mb-2.5 w-96">
                    {`${translate(
                        'You do not have permission to access this resource. If you believe this is an error, please contact the system administrator or support team for assistance.'
                    )}`}
                    .
                </p>
                <a title={`${translate('Login')}`} href={`${SETTINGS.BASE_URL}login`}>{`${translate('Login')}`}</a>
            </div>
        );
    }
}

export default AccessForbidden;
